import { AbstractTreeValueChooser, _AbstractTreeValueChooser } from "./abstract.treevaluechooser";

export interface _AbstractListTreeValueChooser extends _AbstractTreeValueChooser {}

export declare class AbstractListTreeValueChooser extends AbstractTreeValueChooser {}
